import type { Backtest } from "../types/backtests";

function hasNestedExitPlacementSimRows(bt: Backtest): boolean {
  const rows = bt.result?.simulated_trades;
  if (!Array.isArray(rows) || rows.length === 0) return false;
  // Sample a few rows — exit-placement outcomes are `{ trade_id, baseline, simulated, delta }`.
  for (const raw of rows.slice(0, 8)) {
    if (!raw || typeof raw !== "object" || Array.isArray(raw)) continue;
    const row = raw as Record<string, unknown>;
    if (row.simulated && typeof row.simulated === "object" && !Array.isArray(row.simulated)) {
      return true;
    }
  }
  return false;
}

/** Exit Placement / trade-management backtests use baseline vs simulated overlay, not kept/removed veto tags. */
export function isTradeManagementBacktest(bt: Backtest | undefined | null): boolean {
  if (!bt) return false;
  const scope = bt.scope as Record<string, unknown> | undefined;
  if (scope?.simulate_legs != null) return true;
  const simulatedLegs = scope?.simulated_legs;
  if (Array.isArray(simulatedLegs) && simulatedLegs.length > 0) return true;
  // policy_tree.v2 is shared by Regime veto sims and Exit Placement — do not use it alone.
  const snap = bt.input_snapshot;
  if (snap && typeof snap === "object" && !Array.isArray(snap)) {
    const snapObj = snap as Record<string, unknown>;
    if (snapObj.simulate_legs != null) return true;
    const snapLegs = snapObj.simulated_legs;
    if (Array.isArray(snapLegs) && snapLegs.length > 0) return true;
  }
  // Slim list/detail scope omits simulate_legs — detect nested sim outcomes instead.
  if (hasNestedExitPlacementSimRows(bt)) return true;
  return false;
}
